const React = require('react');
const ReactDOM = require('react-dom');
const { ApolloProvider,  } = require('react-apollo');
const { InMemoryCache } = require('apollo-cache-inmemory');

const { logError } = require('./error_logger');
const { buildApolloClient } = require('@reverbdotcom/discovery-ui');

const init = (global, dom) => {
  const CLASS_NAME_ATTR = 'data-react-class';
  const PROPS_ATTR = 'data-react-props';

  const state = document.querySelector('meta[name="apollo-state"]');
  let bootstrap = {};
  if (state && state.content) {
    try {
      bootstrap = JSON.parse(atob(state.content));
    } catch (e) {
      console.error('could not bootstrap apollo cache', e);
    }
  }

  const apolloClient = buildApolloClient(bootstrap);

  const all = dom.querySelectorAll('[data-react-class]');
  [].forEach.call(all, (component) => { // querySelectorAll returns a NodeList not an []
    try {
      const name = component.getAttribute(CLASS_NAME_ATTR);
      const props = component.getAttribute(PROPS_ATTR);
      const parsed = JSON.parse(props);

      const constructor = name
        .split('.')
        .reduce((obj, index) => obj[index], global);

      if (!constructor) {
        throw new Error(`Could not find React component ${name}`);
      }

      const componentElement = React.createElement(constructor, parsed);
      const wrapped = React.createElement(
        ApolloProvider,
        { client: apolloClient },
        componentElement,
      );

      ReactDOM.render(wrapped, component);
    } catch(e) {
      logError(e);
    }
  });
};

module.exports = {
  init,
};

document.addEventListener('DOMContentLoaded', init.bind(this, window, document));



// WEBPACK FOOTER //
// ./javascripts/components/react_ujs.js